import { ReactNode } from 'react';
import styled from 'styled-components';
import { Box, BoxProps, Flex } from 'reflexbox';
import { rgba } from 'polished';

const Container = styled(Flex)<{ count?: boolean; tidy?: boolean; borderless?: boolean }>`
	font-size: 15px;
	color: ${(props) => props.theme.colors.slateBlue};
	align-items: center;
	cursor: pointer;
	transition: 0.4s ease-out background-color;
	border-radius: 24px;
	border: ${(props) => (props.borderless ? 'none' : `1px solid ${props.theme.colors.lightBlue}`)};
	box-sizing: border-box;

	${(props) =>
		props.count
			? `
		padding: 5px 15px 5px 10px;
	`
			: `
			width: ${props.tidy ? 32 : 48}px;
			height: ${props.tidy ? 32 : 48}px;
		justify-content: center;
	`}

	svg {
		width: 26px;
		height: 26px;
		display: block;

		path {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}

	&:hover {
		background: ${(props) => rgba(props.theme.colors.slateBlue, 0.1)};

		&:active {
			background: ${(props) => rgba(props.theme.colors.slateBlue, 0.25)};
		}
	}
`;

export function Stat(
	props: BoxProps & {
		icon: ReactNode;
		count?: number;
		tidy?: boolean;
		borderless?: boolean;
		onClick?: () => void;
	},
) {
	return (
		<Container
			{...props}
			count={props.count !== undefined}
			tidy={props.tidy}
			borderless={props.borderless}
		>
			<Box>{props.icon}</Box>
			{props.count !== undefined && <Box ml={1}>{props.count}</Box>}
		</Container>
	);
}
